import styled, { css } from "styled-components";
import { Form } from "formik";
import FormEdit from "assets/icons/form-edit.svg?react";
import { Modal } from "react-bootstrap";
import PublishedWithChanges from "assets/icons/published_with_changes.svg?react";

type ShowTourProps = {
  showTour?: boolean;
};

export const Container = styled.div<ShowTourProps>`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const HeaderPage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

export const Details = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const HeaderInfo = styled.p`
  margin-bottom: 15px;
`;

export const StatusUnitContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

interface IStatusUnit {
  status: string;
}

export const StatusUnit = styled.div<IStatusUnit>`
  min-width: 20px;
  min-height: 20px;
  border-radius: 100%;
  margin-right: 10px;
  background-color: ${({ status }) =>
    status === "on" ? "#00FF00" : "#FF0000"};
`;

export const FormEditIcon = styled(FormEdit)`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  color: #808495;
  line-height: 1;
  margin-top: 10px;
`;

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  gap: 15px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2px;
    margin-bottom: 10px;
  }

  & div:first-of-type {
    margin-bottom: 0;
  }
`;

export const ContentEditEmail = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0;
  align-items: flex-start;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px 0;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    padding: 5px;

    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #000fff;
      border-radius: 100%;
      min-width: 25px;
      min-height: 25px;
      color: white;
    }

    > p {
      margin-top: 5px;
      font-size: 0.75rem;
      text-align: center;
    }
  }
`;

export const StatusSuspension = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.blueClean};
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";
  font-size: 14px;
  line-height: 14px;
  border-radius: 5px;

  & svg {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    & svg {
      min-height: 20px;
      min-width: 20px;
    }
  }
`;

export const Title = styled.h1`
  position: relative;
  z-index: 1;
  color: #262626;
  font-size: 1.5625rem;
  font-weight: bold;
  line-height: 12px;
  margin: 0;
`;

export const Tooltip = styled.label`
  position: relative;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.darkBlue};
  display: flex;
  align-items: center;
  font-weight: 400;
  justify-content: flex-end;

  div {
    cursor: pointer;
    display: flex;
    place-items: center;
  }

  button {
    margin-left: 12px;
    color: white;
    background-color: #f0b01b;
    border: none;
    border-radius: 100%;
    height: 20px;
    width: 20px;

    font-size: 11px;
    font-weight: bold;
    display: flex;
    place-content: center;
    outline: none;
  }

  #question {
    background-color: white;
    color: #363636;
    border-radius: 5px;
    font-size: 12px;
    opacity: 1;
    max-width: 382px;
    border: 1px solid #cfcfcf;
  }

  .__react_component_tooltip.type-dark.place-top:after {
    border-top-color: #cfcfcf !important;
  }
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 15px 0px 15px 0px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;

  button {
    width: 224px;
    height: 50px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    border-radius: 10px;
  }
  .modal-dialog {
    max-width: 648px !important;
    min-height: 316px !important;
    width: 100% !important;
    @media (max-width: 768px) {
      width: auto !important;
    }
  }
`;

export const ModalContentInfosReligue = styled.div`
  display: flex;
  flex-direction: column;

  img {
    margin: 15px auto 0;
    height: 100%;
    width: 200px;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 26px 35px 26px;
  font-family: "Mangueira";
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .wrapper {
    display: flex;
    justify-content: center;

    img {
      margin-right: 15px;
    }
  }

  span {
    color: #000fff;
    font-size: 1.25rem;
  }

  svg {
    color: #000fff;
    cursor: pointer;
  }
`;

export const ModalBody = styled.div`
  h2 {
    color: #000fff;
    font-size: 1.5rem;
    line-height: 24px;
    text-align: left;
    margin-bottom: 25px;
    width: 100%;
    text-align: center;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 1rem;
    line-height: 25px;
    margin-bottom: 0;

    @media only screen and (max-width: 500px) {
      text-align: center;
    }
  }
`;

export const ModalContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }

  > svg {
    margin-right: 15px;
    flex-shrink: 0;

    @media only screen and (max-width: 500px) {
      margin-right: 0;
      margin-bottom: 15px;
    }
  }
`;

interface IModalFooter {
  isNotButtonFull?: boolean;
}

export const ModalFooter = styled.footer<IModalFooter>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button:nth-child(2) {
    margin-left: 27px;
  }

  button {
    width: 100%;
    height: 50px;
  }

  ${(props) =>
    props.isNotButtonFull &&
    css`
      button {
        width: 200px;
        margin: 0 auto;
      }
    `}
`;

export const PublishedWithChangesIcons = styled(PublishedWithChanges)`
  width: 48px;
  height: 48px;
  path {
    .a {
      fill: #ff8000 !important;
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const TooltipParagraph = styled.p`
  width: 440px;
  @media (max-width: 768px) {
    width: 320px;
  }
  @media (max-width: 375px) {
    width: 250px;
  }
  @media (max-width: 320px) {
    width: 200px;
  }
`;

export const BlockMessager = styled.span`
  margin-top: 15px;
  margin-bottom: 14px;
  color: #5e5e5e;
`;

export const InfoContainer = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const InfoCard = styled.li`
  font-weight: 400;
  color: #0000ff;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem #0000001a;
  border-radius: 0.625rem;
  padding: 0.9375rem;

  b {
    font-weight: 900;
  }

  & + li {
    margin-top: 1.25rem;
  }
`;

export const InfoCardWithImage = styled.li`
  display: flex;
  font-weight: 400;
  color: #0000ff;

  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem #0000001a;

  border-radius: 0.625rem;
  padding: 0.9375rem;
  margin: 1.25rem 0;
`;

export const GreenMark = styled.mark`
  position: absolute;
  z-index: -1;
  padding: 0;
  width: 10.9375rem;
  top: -1.25rem;
  height: 2.5rem;
  left: 2.1875rem;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 65%,
    #000000 50%,
    #28ff00 50%,
    #28ff00 100%
  );
`;

export const Subtitle = styled.h2`
  color: black;
`;

export const DescriptionInfo = styled.p`
  font-weight: 600;
`;

export const IconValve = styled.img`
  height: 4.6875rem;
`;
